const BackgroundColorsLightValues = Object.freeze({
    base: '#FCFCFC',
    tint1: '#f7f7f7',
    tint2: '#f2f2f2',
    tint3: '#D9D9D9',
    border: '#E8E8E8',
    transparent: '#00000085',
    tooltip: '#262626',
    popover: '#FFFFFF',
    gradientUp: 'linear-gradient(360deg, #fcfcfccc 0%, transparent 100%)',
    gradientDown: 'linear-gradient(180deg, #fcfcfccc 0%, transparent 100%)',
    gradientLeft: 'linear-gradient(90deg, #FCFCFC 0%, transparent 100%)',
    gradientRight: 'linear-gradient(270deg, #FCFCFC 0%, transparent 100%)',
    canvasBackLayer: '#EDEDED',
    negativeTransparent: '#000000b3',
});
const BackgroundColorsDarkValues = Object.freeze({
    base: '#121212',
    tint1: '#1c1c1c',
    tint2: '#262626',
    tint3: '#454545',
    border: '#303030',
    transparent: '#00000099',
    tooltip: '#EDEDED',
    popover: '#0F0F0F',
    gradientUp: 'linear-gradient(360deg, #121212cc 0%, transparent 100%)',
    gradientDown: 'linear-gradient(180deg, #121212cc 0%, transparent 100%)',
    gradientLeft: 'linear-gradient(90deg, #121212 0%, transparent 100%)',
    gradientRight: 'linear-gradient(270deg, #121212 0%, transparent 100%)',
    canvasBackLayer: '#262626',
    negativeTransparent: '#ffffffb3',
});
const BackgroundColors = Object.freeze({
    base: 'var(--backgrounds-base)',
    tint1: 'var(--backgrounds-tint-1)',
    tint2: 'var(--backgrounds-tint-2)',
    tint3: 'var(--backgrounds-tint-3)',
    border: 'var(--backgrounds-border)',
    transparent: 'var(--backgrounds-transparent)',
    tooltip: 'var(--backgrounds-tooltip)',
    popover: 'var(--backgrounds-popover)',
    gradientUp: 'var(--backgrounds-gradient-up)',
    gradientDown: 'var(--backgrounds-gradient-down)',
    gradientLeft: 'var(--backgrounds-gradient-left)',
    gradientRight: 'var(--backgrounds-gradient-right)',
    canvasBackLayer: 'var(--backgrounds-canvas-back-layer)',
    negativeTransparent: 'var(--backgrounds-negative-transparent)',
});

export { BackgroundColors, BackgroundColorsDarkValues, BackgroundColorsLightValues };
